import React from 'react';
import { LuPanelRight } from 'react-icons/lu';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/utils/cn';

interface SidebarToggleButtonProps {
    closeLabel?: string;
    isOpen: boolean;
    onToggle: () => void;
    openLabel?: string;
}

export const SidebarToggleButton: React.FC<SidebarToggleButtonProps> = ({
    closeLabel = 'Close sidebar',
    isOpen,
    onToggle,
    openLabel = 'Open sidebar',
}) => {
    return (
        <Tooltip delayDuration={100}>
            <TooltipTrigger asChild>
                <button
                    type="button"
                    aria-pressed={isOpen}
                    onClick={onToggle}
                    className={cn(
                        'hover:bg-cocoa-0 text-cocoa-500 hover:text-cocoa-700 focus-visible:ring-cocoa-300 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent p-1 transition-colors focus-visible:ring-2 focus-visible:ring-offset-2',
                        isOpen && 'bg-cocoa-0 text-cocoa-700',
                    )}
                >
                    <LuPanelRight className="h-4 w-4" />
                </button>
            </TooltipTrigger>
            <TooltipContent side="bottom">
                <p>{isOpen ? closeLabel : openLabel}</p>
            </TooltipContent>
        </Tooltip>
    );
};
